export default class ChangeCoverAbstractServices {
  static getChangeCoverLandingPageReferenceData() {
    logger.error(`ChangeCover:: getChangeCoverReferenceData() not implemented`);
  }

  static getCaptureAdditionalInformationReferenceData() {
    logger.error(`ChangeCover:: getCaptureAdditionalInformationReferenceData() not implemented`);
  }

  static getAddRemovePersonReferenceData() {
    logger.error(`ChangeCover:: getAddRemovePersonReferenceData() not implemented`);
  }

  static getPremiumImpactReferenceData() {
    logger.error(`ChangeCover:: getPremiumImpactReferenceData() not implemented`);
  }

  static getTerminationReasonFlexCodes() {
    logger.error(`ChangeCover:: getTerminationReasonFlexCodes() not implemented`);
  }

  static getFundNames() {
    logger.error(`ChangeCover:: getFundNames() not implemented`);
  }

  static getMpCoverDetails() {
    logger.error(`ChangeCover:: getMpCoverDetails() not implemented`);
  }

  static getDuplicatePerson() {
    logger.error(`ChangeCover:: getDuplicatePerson() not implemented`);
  }

  static submitChangeCover() {
    logger.error(`ChangeCover:: submitChangeCover() not implemented`);
  }

  static raiseDuplicatePersonWorkItem() {
    logger.error(`ChangeCover:: raiseDuplicatePersonWorkItem() not implemented`);
  }

  static retrieveNewPolicyScaleFromEAI() {
    logger.error(`ChangeCover:: retrieveNewPolicyScaleFromEAI() not implemented`);
  }

  static retrieveNewPolicyPremiumFromEAI() {
    logger.error(`ChangeCover:: retrieveNewPolicyPremiumFromEAI() not implemented`);
  }

  static fetchMemberProductHistory() {
    logger.error(`ChangeCover:: fetchMemberProductHistory() not implemented`);
  }

  static getMemberPolicies() {
    logger.error('MemberDetails:: getMemberPolicies() not implemented');
  }
}
